import React from 'react';
import { translationKeys } from '@gik/homepage/i18n/en';
import i18n from '@gik/i18n';
import BenefitTile, { BenefitTileProps } from '@gik/homepage/components/BenefitTile/BenefitTile';
import bemBlock from '@gik/core/utils/bemBlock';
import { Container, SvgIconProps } from '@gik/ui';

const blockName = 'benefits';

export default function Benefits() {
  const bem = bemBlock(blockName);
  const defaultOptions: Partial<SvgIconProps> = {
    size: '2xl',
    set: 'hero-icons',
  };

  const benefits: BenefitTileProps[] = [
    {
      icon: {
        name: 'LinkOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureShareTitle),
      copy: i18n.t(translationKeys.featureShareCopy),
    },
    {
      icon: {
        name: 'UserGroupOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureAddOrganizerTitle),
      copy: i18n.t(translationKeys.featureAddOrganizerCopy),
    },
    {
      icon: {
        name: 'EyeOffOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featurePrivacyTitle),
      copy: i18n.t(translationKeys.featurePrivacyCopy),
    },
    {
      icon: {
        name: 'EatOutline',
        size: '2xl',
        set: 'gik-icons',
      },
      title: i18n.t(translationKeys.featureEatTitle),
      copy: i18n.t(translationKeys.featureEatCopy),
    },
    {
      icon: {
        name: 'CreditCardOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureCardTitle),
      copy: i18n.t(translationKeys.featureCardCopy),
    },
    {
      icon: {
        name: 'GiftOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureGiftTitle),
      copy: i18n.t(translationKeys.featureGiftCopy),
    },
    {
      icon: {
        name: 'NewspaperOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureArticlesTitle),
      copy: i18n.t(translationKeys.featureArticlesCopy),
    },
    {
      icon: {
        name: 'ReminderOutline',
        size: '2xl',
        set: 'gik-icons',
      },
      title: i18n.t(translationKeys.featureRemindersTitle),
      copy: i18n.t(translationKeys.featureRemindersCopy),
    },
    {
      icon: {
        name: 'ChatAlt2Outline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureSupportTitle),
      copy: i18n.t(translationKeys.featureSupportCopy),
    },
    {
      icon: {
        name: 'SparklesOutline',
        ...defaultOptions,
      },
      title: i18n.t(translationKeys.featureFreeTitle),
      copy: i18n.t(translationKeys.featureFreeCopy),
    },
  ];

  return (
    <Container className={bem()} element="section">
      {/* TODO i18n */}
      <h2 className={bem('title')}>Features as unique as your situation</h2>

      <div className={bem('grid')}>
        {benefits.map((feature, key) => (
          <BenefitTile key={key} {...feature} />
        ))}
      </div>
    </Container>
  );
}
